/**
 * @file step
 * @author zhaomiaoyuan
 */
import React from 'react';
// import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
// import {markTypeObj} from './markType';
// import {Popover} from 'antd';
// import InputFormItem from '../../components/InputFormItem/index.tsx';

// import {recordProxy, bCat_2055_request} from '../../util';
// import iconScan from '../../asset/img/scan.svg';


const VerifyParter = (props) => {
    const {
        verifyMsgData,
        // updateVerifyMsg
    } = props;
    // const [connectType, setConnectType] = useState('phone');
    // const onSubmit = () => {
    //     let errFlag = false;
    //     updateVerifyMsg({
    //         companyNameErr: '',
    //         connectPhoneErr: '',
    //         connectEmailErr: ''
    //     });

    //     if (!verifyMsgData.companyName) {
    //         updateVerifyMsg({companyNameErr: '企业名称不能为空'});
    //         errFlag = true;
    //     }
    //     if (connectType === 'phone') {
    //         if (!verifyMsgData.connectPhone) {
    //             updateVerifyMsg({connectPhoneErr: '手机号码不能为空'});
    //             errFlag = true;
    //         }
    //     } else {
    //         const emailTest = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    //         if (!verifyMsgData.connectEmail) {
    //             updateVerifyMsg({connectEmailErr: '邮箱不能为空'});
    //             errFlag = true;
    //         }else if (!emailTest.test(verifyMsgData.connectEmail)) {
    //             console.log('get in');
    //             updateVerifyMsg({connectEmailErr: '邮箱格式不正确'});
    //             errFlag = true;
    //         }
    //     }
    //     if (errFlag) {
    //         return;
    //     } else {
    //         console.log('go');
    //     }
    // };
    // const qrcodeUrl = (
    //     window.location.host.indexOf(':8066') > -1
    //     || window.location.host.indexOf('safe-mobsec06.bcc-bdbl.baidu.com') > -1)
    //     ? 'http://safe-mobsec06.bcc-bdbl.baidu.com:8879' : 'https://mhaoma.baidu.com';

    // const qrCode = (
    //     <img
    //         className="qr-code"
    //         src={window.location.origin + '/api/v1/qr_code?url='
    //             + encodeURIComponent(
    //                 `${qrcodeUrl}/pages/business-card/business-card?company_name=`
    //                 + `${verifyMsgData.distributor.company_name}&scan=true`
    //             )}
    //     />
    // );
    return (
        <div className="verify-part">
            <div className="verify-parter-show">
                <div className="verify-parter-tip">请联系官方合作伙伴修改：</div>
                <div className="verify-parter-content">
                    <div className="verify-parter-logo">
                        <img
                            src={verifyMsgData.distributor.logo_url}
                        />
                    </div>
                    <div className="verify-parter-center">
                        <div className="verify-parter-title">
                            {verifyMsgData.distributor.company_name}
                        </div>
                        <div className="verify-parter-text">
                            <p>电话：{verifyMsgData.distributor.contact}</p>
                            <p>邮箱：{verifyMsgData.distributor.email}</p>
                            <p>地址：{verifyMsgData.distributor.address}</p>
                        </div>
                    </div>
                    {/* <button className="scan-btn">
                        <Popover
                            trigger="hover"
                            content={qrCode}
                            placement="bottom"
                            overlayClassName="verify-scan-pop"
                        >
                            <img style={{'verticalAlign': 'bottom', 'marginRight': '5px'}} src={iconScan}></img>扫码拨号
                        </Popover>
                    </button> */}
                </div>
            </div>
        </div>
    );
};
VerifyParter.propTypes = {
    updateVerifyMsg: PropTypes.func,
    verifyMsgData: PropTypes.object,
};

export default VerifyParter;